import {Box, Stack} from "@mui/material"
import React, {useEffect} from "react"
import Content from "../../components/Content"

export const containerRootDrawerPrototype = [
    {
        key: "identifier",
        type: "STRING",
        label: "Identifier",
        size: 6,
    },
    {
        key: "closeAction",
        type: "STRING",
        defaultValue: "",
        label: "Action wenn Drawer schließt",
        size: 6,
    },
]

const ContainerRootDrawer = ({container, triggerAction}) => {
    const {action, containerSpacing = 16} = container
    useEffect(() => {
        action && triggerAction(action)
    }, [])
    return (
        <Stack spacing={`${containerSpacing}px`}>
            {container.children?.map((child) => (
                <Box key={child.id}>
                    <Content child={child} />
                </Box>
            ))}
        </Stack>
    )
}

export default ContainerRootDrawer
